import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
class Storage {
  constructor() {}

  setItem(key: string, value: unknown): this {
    localStorage.setItem(key, JSON.stringify(value));

    return this;
  }

  getItem<T>(key: string): T | null {
    const item: string | null = localStorage.getItem(key);

    if (!item || item === 'undefined') return null;

    try {
      return JSON.parse(item);
    } catch {
      return null;
    }
  }

  deleteItem(key: string): this {
    localStorage.removeItem(key);

    return this;
  }

  clear = () => localStorage.clear();
}

export default Storage;
